<template>
    <div class="card_body">
        <div class="card_content">
            <van-row class="fieldRow">
                <van-col class="field_row" span="16" :class="{'pessoText': props.rightText2}">{{ props.title1 }}</van-col>
                <van-col class="field_row_value" span="8">
                    <div v-if="props.rightText1">{{ props.rightText1 }}</div>
                    <span>{{ props.value1 }}</span>
                    <div v-if="props.rightText2" >{{ props.rightText2 }}</div>
                </van-col>
            </van-row>
            <van-row class="fieldRow">
                <van-col class="field_row" span="16" :class="{'pessoText': props.rightText2}">{{ props.title2 }}</van-col>
                <van-col class="field_row_value" span="8">
                    <div v-if="props.rightText1">{{ props.rightText1 }}</div>
                    <span>{{ props.value2 }}</span>
                    <div v-if="props.rightText2" >{{ props.rightText2 }}</div>
                </van-col>
            </van-row>
            <!-- <van-row class="totalRow">
                <van-col class="total_row" span="16">{{ props.title3 }}</van-col>
                <van-col class="field_row_value" span="8">
                    <div v-if="props.rightText1">{{ props.rightText1 }}</div>
                    <span>{{ props.value3 }}</span>
                    <div v-if="props.rightText2">{{ props.rightText2 }}</div>
                </van-col>
            </van-row> -->
        </div>
    </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';
const props = defineProps({
    title1: {
        type: String,
        default: () => ''
    },
    title2: {
        type: String,
        default: () => ''
    },
    title3: {
        type: String,
        default: () => ''
    },
    value1: {
        type: [String, Number],
        default: () => 0
    },
    value2: {
        type: [String, Number],
        default: () => 0
    },
    value3: {
        type: [String, Number],
        default: () => 0
    },
    rightText1: {
        type: String,
        default: () => ''
    },
    rightText2: {
        type: String,
        default: () => ''
    },
})

</script>
<style scoped>
.card_body {
    border-radius: 10px;
    overflow: hidden;
    font-size: 15px;
    position: relative;
    margin: 5px 0;
}

.card_body img {
    width: 100%;
}

.card_body img {
    width: 100%;
}

.card_content {
    background: #312734;
    border-radius: 15px;
    margin: 2.5px;
    overflow: hidden;
    font-weight: bold;
    /* position: absolute;
    top: 0; */
}

.field_row {

    padding: 18px 15px;
    color: #fd66b1;
}

.total_row {
    padding: 18px 15px;
    color: rgba(255, 255, 255, 0.85);
    font-weight: bold;
}

.field_row_value {
    padding: 18px 15px;
    color: #ffa200;
    display: flex;
    font-size: 13px;
    justify-content: right;
    align-items: center;
}
.pessoText{
    color:#d390ff;
}
.field_row_value span {
    padding: 0 5px;
    color: #fe0;
    font-weight: bold;
    font-size: 16px;
}
.fieldRow{
    border-bottom: #ffffff1f 1px solid;
}
.totalRow{
    background: #ffffff38;
    
}
</style>